export default __webpack_public_path__ + "static/media/14.eea45bf8.png";